<template>
  <div class="statement-react">
    <add-button v-if="canAddToConvo" @toggleOn="addConvoCommentStatement()" />
    <jybe-button v-bind:statement="statement" @react="$emit('react')" />
    <consider-button v-bind:statement="statement" @react="$emit('react')" />
    <ignore-button v-bind:statement="statement" @react="$emit('react')" />
    <copy-button @copy="copyStatement()" v-bind:type="'fal'" v-bind:icon="'comment-alt-check'"/>
    <share-button v-bind:type="'statements'" v-bind:id="statement.id" />
  </div>
</template>

<script>
  import StatementReact from "./StatementReact.ts";

  export default StatementReact
</script>
